import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase, apiGeneratorDelete } from "../../../Utils/saga"
import BusinessAccountsActions from "../../BusinessAccountsPage/reducer"
import Creators, { RequestsAutoRefundTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getRequestsAutoRefundFilterOptionsActions: {
    request: Creators.getRequestsAutoRefundFilterOptionsRequest,
    success: Creators.getRequestsAutoRefundFilterOptionsSuccess,
    errors: Creators.getRequestsAutoRefundFilterOptionsFailure
  },
  getRequestsAutoRefundActions: {
    request: Creators.getRequestsAutoRefundRequest,
    success: Creators.getRequestsAutoRefundSuccess,
    errors: Creators.requestsAutoRefundFailure
  },
  updateRequestsAutoRefundActions: {
    request: Creators.updateRequestsAutoRefundRequest,
    success: Creators.updateRequestsAutoRefundSuccess,
    errors: Creators.requestsAutoRefundFailure,
    extraAction: [BusinessAccountsActions.getStatisticsAdminRequest]
  },
  deleteRequestsAutoRefundActions: {
    request: Creators.deleteRequestsAutoRefundRequest,
    success: Creators.deleteRequestsAutoRefundSuccess,
    errors: Creators.requestsAutoRefundFailure,
    extraAction: [BusinessAccountsActions.getStatisticsAdminRequest]
  },
  getRequestsAutoRefundExportActions: {
    request: Creators.getRequestsAutoRefundExportRequest,
    success: Creators.getRequestsAutoRefundExportSuccess,
    errors: Creators.getRequestsAutoRefundExportFailure
    //downloadFile: true,
  }
}

const eventsOptions = {
  [constants.GET_REQUESTS_AUTO_REFUND_FILTER_OPTIONS_REQUEST]: {
    api: services.getRequestsAutoRefundFilterOptions,
    actions: actions.getRequestsAutoRefundFilterOptionsActions
  },
  [constants.GET_REQUESTS_AUTO_REFUND_REQUEST]: {
    api: services.getAutoRefundRequests,
    actions: actions.getRequestsAutoRefundActions
  },
  [constants.UPDATE_REQUESTS_AUTO_REFUND_REQUEST]: {
    api: services.updateAutoRefundRequests,
    actions: actions.updateRequestsAutoRefundActions
  },
  [constants.DELETE_REQUESTS_AUTO_REFUND_REQUEST]: {
    api: services.deleteAutoRefundRequests,
    actions: actions.deleteRequestsAutoRefundActions
  },
  [constants.GET_REQUESTS_AUTO_REFUND_EXPORT_REQUEST]: {
    api: services.getRequestsAutoRefundExport,
    actions: actions.getRequestsAutoRefundExportActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_REQUESTS_AUTO_REFUND_FILTER_OPTIONS_REQUEST, (action) =>
    apiGeneratorBase(
      action,
      eventsOptions[constants.GET_REQUESTS_AUTO_REFUND_FILTER_OPTIONS_REQUEST]
    )
  )
  yield takeLatest(constants.GET_REQUESTS_AUTO_REFUND_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_REQUESTS_AUTO_REFUND_REQUEST])
  )
  yield takeLatest(constants.UPDATE_REQUESTS_AUTO_REFUND_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.UPDATE_REQUESTS_AUTO_REFUND_REQUEST])
  )
  yield takeLatest(constants.DELETE_REQUESTS_AUTO_REFUND_REQUEST, (action) =>
    apiGeneratorDelete(action, eventsOptions[constants.DELETE_REQUESTS_AUTO_REFUND_REQUEST])
  )
  yield takeLatest(constants.GET_REQUESTS_AUTO_REFUND_EXPORT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_REQUESTS_AUTO_REFUND_EXPORT_REQUEST])
  )
}
